import { Component, OnInit, Input } from '@angular/core';
import { courseObject } from '../../services/software.service.model';
import { environment } from 'src/environments/environment';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {
  @Input() courseData: courseObject;
  @Input() RTLFlag: boolean;
  @Input() hasSoftware: boolean;
  @Input() consoleType: string;
  cloudBasePath: string;


  constructor(private _amplitudeAnalytics: AmplitudeAnalyticsService) { }

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
  }

  downloadFile(type: string, redirectURL: URL): void {
    window.open(redirectURL.toString());
    // this._amplitudeAnalytics.logEvent(
    //   'Software - Lifescape Update - Download',
    //   {
    //     Console_Type: this.consoleType,
    //     Course_Type: type
    //   }
    // );
  }
}
